import { axiosInstanceMain } from '../../../../utils/axiosGlobalUtils'
import { ITenant } from '../../../AbmLocalPage/types'

export const getAtributosRubro = async (tenant: ITenant) =>
  await axiosInstanceMain.get(`admin/${tenant.path}/productos/atributos`)

export const getGruposAtr = async (tenant: ITenant) => await axiosInstanceMain.get(`/${tenant.path}/rubros/grupos`)

export const getUnidadesDeMedida = async (tenant: ITenant) =>
  await axiosInstanceMain.get(`admin/${tenant.path}/productos/unidades-de-medida`)

export const getMonedas = async (tenant: ITenant) =>
  await axiosInstanceMain.get(`admin/${tenant.path}/monedas`)
